import React from "react";
import { useDispatch } from "react-redux";
import styles from '../styling/CreatedTransaction.module.css'

function CreatedTransaction({name, category, amount, id}) {
    const dispatch = useDispatch()

    const handleClick = () => {
        dispatch({
            type: 'transactions/removeTransaction',
            payload: {
                'category': category,
                'id': id
            }
        })
    }

    return (
        <div className={styles.div} >
            <p className={styles.p}>{name}</p>
            <p className={styles.p}>{category}</p>
            <p className={styles.p}>${amount}</p>
            <button className={styles.button} onClick={handleClick} >X</button>
        </div>
    )
}

export default CreatedTransaction;